export interface AvatarProps {
  size?: 'sm' | 'md' | 'lg';
  src?: string;
  initials?: string;
  name?: string;
  status?: 'online' | 'offline' | 'busy' | null;
  className?: string;
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
} as const;

const dotSizeClasses = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2 h-2',
  lg: 'w-2.5 h-2.5',
} as const;

const fontSizeClasses = {
  sm: 'text-sd-xs',
  md: 'text-sd-sm',
  lg: 'text-sd-base',
} as const;

const statusColorClasses = {
  online: 'bg-sd-success',
  offline: 'bg-sd-text-muted',
  busy: 'bg-sd-warning',
} as const;

export function Avatar({
  size = 'md',
  src,
  initials,
  name,
  status = null,
  className = '',
}: AvatarProps) {
  const label = name || initials || '';

  return (
    <span
      className={`relative inline-flex items-center justify-center rounded-sd-full overflow-hidden ring-2 ring-sd-border/50 ${sizeClasses[size]} ${className}`.trim()}
      aria-label={label || undefined}
      role={src ? undefined : 'img'}
    >
      {src ? (
        <img
          src={src}
          alt={label}
          className="w-full h-full object-cover"
        />
      ) : (
        <span
          className={`w-full h-full flex items-center justify-center bg-sd-primary-subtle text-sd-primary font-bold tracking-wide uppercase ${fontSizeClasses[size]}`}
        >
          {initials}
        </span>
      )}
      {status && (
        <span
          className={`absolute bottom-0 right-0 rounded-sd-full border-2 border-sd-surface ${dotSizeClasses[size]} ${statusColorClasses[status]}`}
          aria-hidden="true"
        />
      )}
    </span>
  );
}
